<template>
    <span class="activate-toggle">
        <a href="#" class="btn btn-success btn-sm" v-if="isActive" @click.prevent="toggleActive(product)">
            Aktív
        </a>
        <a href="#" class="btn btn-warning btn-sm" v-else @click.prevent="toggleActive(product)">
            Inaktív
        </a>
    </span>
</template>

<script>
    export default {
        props: ['product', 'active'],

        data: function() {
            return {
                isActive: '',
            }
        },

        mounted() {
            // Init from passed parameter
            this.isActive = this.isActiveInit ? true : false;
        },

        computed: {
            isActiveInit() {
                return this.active;
            },
        },

        methods: {
            toggleActive(product) {

                // AJAX post
                axios.post('/hirdetes/activate-toggle/' + product)
                    .then(response => {
                        // Update based on the response
                        this.isActive = response.data.isActive;

                        if (this.isActive) {
                            this.showAlert('success', 'Hirdetés aktiválva');
                        } else {
                            this.showAlert('info', 'Hirdetés inaktiválva');
                        }

                    })
                    .catch(response => console.log(response.data));
            },

            showAlert(icon, text) {
                Swal.fire({
                    icon: icon,
                    title: text,
                    showConfirmButton: false,
                    timer: 1000
                })
            }
        }
    }
</script>